class FormAddressData extends FormData {
    data;
    constructor(data) {
        super();
        this.data = data;
        this.buildAddressForm();
    }
    buildAddressForm() {
        this.append('typeOfRoad', this.data.typeOfRoad);
        this.append('street', this.data.street);
        this.append('externalNumber', this.data.externalNumber);
        this.append('internalNumber', (this.data.internalNumber ?? ''));
        this.append('zipCode', this.data.zipCode);
        this.append('neighborhood', this.data.neighborhood);
        this.append('municipality', this.data.municipality);
        this.append('city', this.data.city);
        this.append('state', this.data.state);
        this.append('country', this.data.country);
    }
}
export default FormAddressData;
